import React from "react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-[#18344A]">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-[rgba(48,56,60,0.65)]">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}
